import { Link } from "react-router-dom";

import { useScrollReveal } from "../../../hooks/useScrollReveal";
import "./Pricing01.css";

import Button01 from "../../core/Button01";

import icon from "../../../img/icons/check.svg";

function Pricing01() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <div
      ref={ref}
      className={`Pricing01 section section-reveal ${isVisible ? "section--visible" : ""}`}
      id="Pricing01"
    >
      <div className="container">
        <div className="intro">
          <p className="eyebrow">Pricing</p>
          <h2>One Membership. Total Protection.</h2>
          <p>
            Representation is highly selective. Submit your profile for
            consideration today.
          </p>
        </div>
        <div className="Pricing01-box">
          <div className="Pricing01-box-top">
            <h3>@SERVED MEMBERSHIP</h3>
            <p>A private protection system designed for modern creators.</p>
          </div>

          <Button01 />

          <ul>
            <li>
              <img src={icon} alt="tick icon" /> Legally Binding{" "}
              <span>DMCA</span> Takedowns
            </li>
            <li>
              <img src={icon} alt="tick icon" /> Search Engine{" "}
              <span>De-Indexing</span>
            </li>

            <li>
              <img src={icon} alt="tick icon" /> Cross-Platform{" "}
              <span>Content Removal</span>
            </li>

            <li>
              <img src={icon} alt="tick icon" /> Early Leak Detection
            </li>

            <li>
              <img src={icon} alt="tick icon" /> <span>AI Deepfake</span>{" "}
              Protection
            </li>

            <li>
              <img src={icon} alt="tick icon" /> Visual Clone Detection
            </li>

            <li>
              <img src={icon} alt="tick icon" /> Repost Network Tracking
            </li>

            <li>
              <img src={icon} alt="tick icon" /> <span>Global</span> Enforcement
              Coverage
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Pricing01;
